module.exports = __webpack_public_path__ + "static/img/tag_zqzf.8799ccee.png";